import React from 'react';
import TutorialModal from '../TutorialModal/TutorialModal';
import {InlineTokenIcon, LegendRow} from "./chapter1Modals";
import PlayerFactionIcon from "../../PlayerFactionIcon/PlayerFactionIcon";
import {FACTIONS} from "../../../constants/factions";
import PlayerPolicyIcon from "../../PlayerPolicyIcon/PlayerPolicyIcon";
import {POLICIES} from "../../../constants/policies";
import {TutorialDamageDice} from "../TutorialDamageDice/TutorialDamageDice";
import {getMountainImage} from "../../../configs/mountainTiles";
import {TUTORIAL_CHAPTER_3} from "../../../configs/tutorial/chapter3";

/**
 * Обучающие модалки главы 3 (политики, пути влияния, катапульты, крепости).
 * Формат и стиль — как в chapter1Modals; идентификаторы — в
 * tutorialModalsRegistry.
 */

// Гора в окнах главы — та же, что на ее поле: подложка у главы постоянная
const CHAPTER_MOUNTAIN_IMAGE = getMountainImage(TUTORIAL_CHAPTER_3.groundBackground);

export const Ch3WelcomeModal = () => (
  <TutorialModal title={'Глава 3: Магистр Вентори'} buttonText={'Начать главу'}>
    <LegendRow
      icon={<PlayerFactionIcon
        player={{color: 'orange'}}
        factionId={FACTIONS.VENTORY}
        className={'tutorial-modal_faction-icon'}
      />}
      iconBoxClassName={'card-icon'}
      label={<>
        Новый противник — <b>Вентори</b>, народ торговцев.
        <br/>Их город с двумя рудниками стоит у самых твоих границ, а главный город укрылся на севере.
      </>}
    />
    <p>
      Вентори получают повышенный доход от Гильдий<InlineTokenIcon
      src={'/img/hexes/special buildings/guild.ee26d2b8.png'} alt={'Гильдия'}
    /> и Храмов<InlineTokenIcon src={'/img/hexes/special buildings/temple.17c08b3d.png'} alt={'Храм'}/>.
    </p>
    <LegendRow
      src={'/img/icons/rules.png'}
      label={<>
        В этой главе познакомимся с <b>рынком политик</b>, гильдиями, храмами, катапультами и крепостями.
      </>}
    />
  </TutorialModal>
);

export const Ch3PolicyMarketModal = () => (
  <TutorialModal title={'Рынок политик'}>

    <LegendRow
      src={'/img/icons/governance_black.png'} label={<>
      В <span className={'text-construction'}>фазе Строительства</span> можно купить <b>политику</b> — постоянный бонус
      государства:
      <br/>• Цена политики равна её позиции в ряду рынка (от <span className={'text-coins-dark'}>1</span> до <span
      className={'text-coins-dark'}
    >6</span><InlineTokenIcon src={'/img/icons/coins.png'} alt={'Монеты'}/>).
      <br/>• Покупать можно не более одной политики за ход.
      <br/>• Политики можно менять по ходу матча.
    </>}
    />
    <LegendRow
      src={'/img/icons/exclamation-mark.png'} label={<>
      Политика начинает действовать <span className={'text-war'}>сразу</span>, если у игрока до
      этого <span className={'text-construction'}>не было политики</span>.
      <br/>Если у игрока <span className={'text-construction'}>уже была политика</span>, то старая закончит действовать
      в конце раунда.
      А <span className={'text-construction'}>купленная начнёт работать</span><span className={'text-war'}> с начала следующего раунда</span>.
    </>}
    />

    <LegendRow
      icon={<PlayerFactionIcon
        player={{color: 'blue'}}
        factionId={FACTIONS.HUMANS}
        className={'tutorial-modal_faction-icon'}
      />}
      iconBoxClassName={'card-icon'}
      label={<>
        Фракция Людей имеет скидку <span className={'text-coins-dark'}>3 монеты</span><InlineTokenIcon
        src={'/img/icons/coins.png'} alt={'Монеты'}
      /> на покупку всех политик.
        <br/>И <span className={'text-construction'}>новая политика начинает действовать сразу</span>, даже если у Людей
        до этого уже была другая политика
        (старая политика сбрасывается мгновенно).
      </>}
    />

    <LegendRow
      src={'/img/icons/arrow_down_big.png'} label={<>
      Купи политику <span className={'text-construction'}>Индустриализм</span>: он даст +1 действие<InlineTokenIcon
      src={'/img/icons/action.png'} alt={'Действие в фазе Строительства'}
    /> — и уже в этой <span className={'text-construction'}>фазе Строительства</span> у тебя будет 3 действия<InlineTokenIcon
      src={'/img/icons/action.png'} alt={'Действие фазы Строительства'}
    />.
    </>}
    />
    <p>

    </p>
  </TutorialModal>
);

export const Ch3PolicyShownModal = () => (
  <TutorialModal title={'Твоя политика активна'}>
    <p>Индустриализм куплен!</p>
    <LegendRow
      icon={<PlayerPolicyIcon
        player={{color: 'blue', policy: {id: POLICIES.INDUSTRIALISM, name: 'Индустриализм'}}}
        className={'tutorial-modal_faction-icon'}
      />}
      iconBoxClassName={'card-icon'}
      label={<>
        Твоя действующая политика видна в шапке — нажатие на нее открывает ее карточку. Рынок
        политик<InlineTokenIcon src={'/img/icons/governance_black.png'} alt={'Рынок политик'}/> открывают
        его миниатюры в левом углу шапки. На телефоне политика и рынок — на ярлыках у левого края экрана.
      </>}
    />
    <p>
      Политика действует до конца игры — или пока ты не купишь новую.
    </p>
  </TutorialModal>
);

export const Ch3RulesPoliciesModal = () => (
  <TutorialModal title={'Все политики — в правилах'}>
    <LegendRow
      src={'/img/icons/rules.png'}
      label={<>
        Полный список политик с подробными описаниями есть в <b>правилах</b>: их можно открыть в
        любой момент матча пунктом «Правила» в меню матча, а вне матча — кнопкой «Правила» в
        главном меню.
      </>}
    />
    <p>
    </p>
    <LegendRow
      src={'/img/icons/arrow_down_big.png'} label={<>
      Перейди в правилах в раздел <b>«Политики»</b><InlineTokenIcon
      src={'/img/icons/governance_black.png'} alt={'Рынок политик'}
    /> и <b>пролистай страницу вниз</b> — там с каждой политикой можно ознакомиться подробно.
    </>}
    />
  </TutorialModal>
);

export const Ch3EnemyPolicyModal = () => (
  <TutorialModal title={'Противник купил политику'}>

    <LegendRow
      icon={<PlayerFactionIcon
        player={{color: 'orange'}}
        factionId={FACTIONS.VENTORY}
        className={'tutorial-modal_faction-icon'}
      />}
      iconBoxClassName={'card-icon'}
      label={<>
        Вентори тоже купили себе политику. В списке игроков (кружки в шапке) у каждого игрока видна <b>плашка его
        политики</b> — нажми на плашку противника, чтобы ознакомиться с ней.
      </>}
    />

    <LegendRow
      icon={<PlayerPolicyIcon
        player={{color: 'orange', policy: {id: POLICIES.OLIGARCHY, name: 'Олигархия'}}}
        className={'tutorial-modal_faction-icon'}
      />}
      iconBoxClassName={'card-icon'}
      label={<>
        Во время хода противника карточку его политики можно открыть и с кнопки завершения хода — по <b>иконке
        политики</b> на ней. Это мы попробуем чуть позже.
      </>}
    />
  </TutorialModal>
);

export const Ch3GuildInfluenceModal = () => (
  <TutorialModal title={'Гильдия и пути влияния'}>
    <p>Продолжаем знакомиться со <span className={'text-construction'}>специальными строениями</span><InlineTokenIcon
      src={'/img/hexes/special buildings/special building.c496c562.png'} alt={'Специальное строение'}
    />:</p>
    <LegendRow
      src={'/img/hexes/special buildings/guild.ee26d2b8.png'} label={<>
      <b>Гильдия</b> приносит <span className={'text-coins-dark'}>1 монету</span><InlineTokenIcon
      src={'/img/icons/coins.png'} alt={'Монеты'}
    /> в конце каждого раунда.
      <br/>Но ее доход можно повысить за счёт <span className={'text-coins-dark'}>путей влияния</span>:
      <br/><b>за каждый</b> <span className={'text-war'}>вражеский город</span><InlineTokenIcon
      src={'/img/icons/city.42008716.png'} alt={'Город'}
    />, до которого можно провести путь длиной до 5 ячеек, доход повышается на <span className={'text-coins-dark'}>1 монету</span><InlineTokenIcon
      src={'/img/icons/coins.png'} alt={'Монеты'}
    />.
    </>}
    />
    <LegendRow
      src={'/img/icons/exclamation-mark.png'} label={<>
      <span className={'text-coins-dark'}>Путь влияния</span> <span className={'text-war'}>не может</span> проходить по пустым ячейкам<InlineTokenIcon
      src={'/img/icons/cell.png'} alt={'Ячейка'}
    />.
    </>}
    />

    <LegendRow
      src={'/img/icons/arrow_down_big.png'} label={<>
      Построй <span className={'text-construction'}>Гильдию</span> на указанном <span className={'text-construction'}>Базовом квартале</span><InlineTokenIcon
      src={'/img/hexes/quarter.f69660fa.png'} alt={'Базовый квартал'}
    />:
      после размещения на поле ты увидишь анимацию, которая покажет доход и <span className={'text-coins-dark'}>пути влияния</span> Гильдии<InlineTokenIcon
      src={'/img/hexes/special buildings/guild.ee26d2b8.png'} alt={'Гильдия'}
    />.
    </>}
    />
  </TutorialModal>
);

export const Ch3CellInfoModal = () => (
  <TutorialModal title={'Информация о ячейке'}>
    <p>
      Ты всегда можешь нажать на <b>любую ячейку поля</b><InlineTokenIcon src={'/img/icons/cell.png'} alt={'Ячейка'}/>
      — откроется панель с подробной информацией о ней: строение, владелец, доход, снабжение.
    </p>

    <LegendRow
      src={'/img/icons/arrow_down_big.png'} label={<>
      Посмотри сначала ячейку с Храмом<InlineTokenIcon src={'/img/hexes/special buildings/temple.17c08b3d.png'} alt={'Храм'}/>, а
      затем — со Складом<InlineTokenIcon src={'/img/hexes/special buildings/warehouse.adf397b3.png'} alt={'Склад'}/>.
    </>}
    />
  </TutorialModal>
);

export const Ch3GuildUniqueModal = () => (
  <TutorialModal title={'Одна гильдия на город'}>

    <LegendRow
      src={'/img/icons/exclamation-mark.png'} label={<>
      В одном городе<InlineTokenIcon src={'/img/icons/city.42008716.png'} alt={'Город'}/> <span className={'text-war'}>не может быть</span>
      {' '}2 <span className={'text-construction'}>специальных строения</span><InlineTokenIcon
      src={'/img/hexes/special buildings/special building.c496c562.png'} alt={'Специальное строение'}
    /> одного
      типа — обрати внимание на подсветку доступных ячеек: вторую Гильдию<InlineTokenIcon
      src={'/img/hexes/special buildings/guild.ee26d2b8.png'} alt={'Гильдия'}
    /> можно построить только в другом городе.
    </>}
    />
    <LegendRow
      src={'/img/icons/arrow_down_big.png'} label={<>
      Построй Гильдию<InlineTokenIcon
      src={'/img/hexes/special buildings/guild.ee26d2b8.png'} alt={'Гильдия'}
    /> и в северном городе — это будет твоё 2-е действие.
    </>}
    />
  </TutorialModal>
);

export const Ch3TempleModal = () => (
  <TutorialModal title={'Храм'}>
    <LegendRow
      src={'/img/hexes/special buildings/temple.17c08b3d.png'} label={<>
      <b>Храм</b> работает так же, как Гильдия<InlineTokenIcon
      src={'/img/hexes/special buildings/guild.ee26d2b8.png'} alt={'Гильдия'}
    />, но приносит <span className={'text-win-points-dark'}>очки</span><InlineTokenIcon
      src={'/img/icons/win points.png'} alt={'Очки'}
    />:
      <br/>• Базовый доход <span className={'text-win-points-dark'}>1</span><InlineTokenIcon
      src={'/img/icons/win points.png'} alt={'Очки'}
    /> за раунд.
      <br/>• И ещё по <span className={'text-win-points-dark'}>1</span><InlineTokenIcon
      src={'/img/icons/win points.png'} alt={'Очки'}
    /> за каждый вражеский город<InlineTokenIcon src={'/img/icons/city.42008716.png'} alt={'Город'}/>, до которого можно
      провести <span className={'text-win-points-dark'}>путь влияния</span>.
    </>}
    />

    <LegendRow
      src={'/img/icons/arrow_down_big.png'} label={<>
      Построй Храм<InlineTokenIcon
      src={'/img/hexes/special buildings/temple.17c08b3d.png'} alt={'Храм'}
    /> на втором <span className={'text-construction'}>Базовом квартале</span><InlineTokenIcon
      src={'/img/hexes/quarter.f69660fa.png'} alt={'Базовый квартал'}
    /> северного города — это будет твоё 3-е действие<InlineTokenIcon
      src={'/img/icons/action.png'} alt={'Действие фазы Строительства'}
    />, которое ты можешь выполнить благодаря купленной политике <span
      className={'text-construction'}
    >Индустриализм</span>.
    </>}
    />
  </TutorialModal>
);

export const Ch3RoadIncomeModal = () => (
  <TutorialModal title={'Дороги продлевают пути влияния'}>
    <LegendRow
      src={'/img/icons/exclamation-mark.png'} label={<>
      <span className={'text-coins-dark'}>Путь влияния</span> <span className={'text-war'}>не может</span> проходить по пустым ячейкам<InlineTokenIcon
      src={'/img/icons/cell.png'} alt={'Ячейка'}
    />.
    </>}
    />
    <LegendRow
      src={'/img/hexes/road.1f281346.png'} label={<>
      Дорога — самое дешёвое строение, <span
      className={'text-coins-dark'}
    >1 монета</span><InlineTokenIcon src={'/img/icons/coins.png'} alt={'Монеты'}/>.
      С помощью неё можно проложить маршруты для снабжения и перемещения отрядов.
      <br/> А также соединить свои Гильдий<InlineTokenIcon
      src={'/img/hexes/special buildings/guild.ee26d2b8.png'} alt={'Гильдия'}
    /> и Храмы<InlineTokenIcon
      src={'/img/hexes/special buildings/temple.17c08b3d.png'} alt={'Храм'}
    /> с городом противника<InlineTokenIcon src={'/img/icons/city.42008716.png'} alt={'Город'}/>, чтобы создать новые <span
      className={'text-coins-dark'}
    >пути влияния</span> и поднять их <span
      className={'text-coins-dark'}
    >доход</span>.
    </>}
    />
    <p>
    </p>

    <LegendRow
      src={'/img/icons/arrow_down_big.png'} label={<>
      Проложи 2 Дороги<InlineTokenIcon src={'/img/hexes/road.1f281346.png'} alt={'Дорога'}/> на север, чтобы создать <span
      className={'text-coins-dark'}
    >новые пути влияния</span>: доход Гильдии<InlineTokenIcon
      src={'/img/hexes/special buildings/guild.ee26d2b8.png'} alt={'Гильдия'}
    /> и Храма<InlineTokenIcon
      src={'/img/hexes/special buildings/temple.17c08b3d.png'} alt={'Храм'}
    /> в твоём северном городе вырастет ещё на <span className={'text-coins-dark'}>+1</span><InlineTokenIcon
      src={'/img/icons/coins.png'} alt={'Монеты'}
    /> и <span className={'text-win-points-dark'}>+1</span><InlineTokenIcon
      src={'/img/icons/win points.png'} alt={'Очки'}
    /> соответственно.
    </>}
    />
  </TutorialModal>
);

export const Ch3VentoryBonusModal = () => (
  <TutorialModal title={'Вентори строят своё'}>
    <LegendRow
      icon={<PlayerFactionIcon
        player={{color: 'orange'}}
        factionId={FACTIONS.VENTORY}
        className={'tutorial-modal_faction-icon'}
      />}
      iconBoxClassName={'card-icon'}
      label={<>
        Противник ответил строительством своих Гильдии<InlineTokenIcon
        src={'/img/hexes/special buildings/guild.ee26d2b8.png'} alt={'Гильдия'}
      /> и Храма<InlineTokenIcon
        src={'/img/hexes/special buildings/temple.17c08b3d.png'} alt={'Храм'}
      />.
      </>}
    />
    <LegendRow
      src={'/img/icons/exclamation-mark.png'} label={<>
      Обрати внимание на их доход — у Вентори он на 1 выше с каждого такого строения: это их фракционный бонус.
    </>}
    />

    <LegendRow
      src={'/img/icons/barracks red.png'} label={<>
      При прочих равных Вентори будут получать больше дохода.
      <br/>Пора навязать им битву, иначе ты проиграешь экономически!
    </>}
    />
  </TutorialModal>
);

export const Ch3CatapultModal = () => (
  <TutorialModal title={'Катапульта'}>
    <p>
    </p>

    <LegendRow
      src={'/img/icons/unit d4 friend.png'} isUnitIcon
      label={<>
        <b>Катапульта</b> — осадный отряд: стреляет<InlineTokenIcon
        src={'/img/icons/shooting.png'} alt={'Стрельба'}
      /> на дальность<InlineTokenIcon src={'/img/icons/distance.png'} alt={'Дальность'}/> <span className={'text-war'}>до 5 ячеек</span>.
        <br/>Горы<InlineTokenIcon src={CHAPTER_MOUNTAIN_IMAGE} alt={'Горы'}/> и Крепости<InlineTokenIcon
        src={'/img/hexes/special buildings/fortress button.6fed26ae.png'} alt={'Крепость'}
      /> на линии мешают выстрелу (траектория от центра ячейки выстрела к центру ячейки цели).
      </>}
    />
    <LegendRow src={'/img/icons/shooting.png'} label={'Может выстрелить 1 раз на этапе Стрельбы в каждой фазе Войны.'}/>
    <LegendRow
      src={'/img/icons/damage.png'}
      label={<>
        <span className={'text-war'}>Урон выстрела</span><InlineTokenIcon
        src={'/img/icons/shooting.png'} alt={'Стрельба'}
      /> = размер<InlineTokenIcon src={'/img/icons/unit size.png'} alt={'Размер отряда'}/> Катапульты + <span
        className={'text-war'}
      >лучший</span> из 2-х бросков <span
        className={'text-war'}
      >костей урона</span>{' '}<TutorialDamageDice value={0} isInline={true}/>.
      </>}
    />
    <LegendRow
      src={'/img/icons/exclamation-mark.png'}
      label={<>
        Если Катапульта<InlineTokenIcon
        src={'/img/icons/unit d4 friend.png'} isUnitIcon alt={'Катапульта'}
      /> перемещалась<InlineTokenIcon src={'/img/icons/speed.png'} alt={'Перемещение'}/> в этом ходу, то при
        расчёте <span className={'text-war'}>урона выстрела</span><InlineTokenIcon
        src={'/img/icons/damage.png'} alt={'Урон'}
      /> будет выбрана <span
        className={'text-war'}
      >худшая кость урона</span>{' '}<TutorialDamageDice value={0} isInline={true}/>.
      </>}
    />

    <LegendRow
      src={'/img/icons/arrow_down_big.png'} label={<>
      Найми Катапульту<InlineTokenIcon src={'/img/icons/unit d4 friend.png'} isUnitIcon alt={'Катапульта'}/> на
      Казарме<InlineTokenIcon src={'/img/hexes/barracks.efab12f7.png'} alt={'Казарма'}/> и докупи ей размер<InlineTokenIcon
      src={'/img/icons/unit size.png'} alt={'Размер отряда'}
    /> до 3 — для первого выстрела этого хватит.
      <br/>На Руинах<InlineTokenIcon src={'/img/hexes/ruins.65862e11.png'} alt={'Руины'}/> в городе<InlineTokenIcon
      src={'/img/icons/city.42008716.png'} alt={'Город'}
    /> Вентори как раз встал вражеский отряд — отличная первая цель.
    </>}
    />
    <p>

    </p>
  </TutorialModal>
);

export const Ch3CatapultGrowthModal = () => (
  <TutorialModal title={'Рост катапульты'}>
    <LegendRow
      src={'/img/icons/unit d4 friend.png'} isUnitIcon
      label={<>
        Снабжённая Катапульта растёт <span className={'text-war'}>только на 1</span><InlineTokenIcon
        src={'/img/icons/unit size.png'} alt={'Размер отряда'}
      /> и <span className={'text-war'}>только на Казарме</span><InlineTokenIcon
        src={'/img/hexes/barracks.efab12f7.png'} alt={'Казарма'}
      /> — остальные отряды на Казарме растут на 2.
      </>}
    />
    <LegendRow
      src={'/img/icons/exclamation-mark.png'}
      label={<>
        Вне Казармы снабжение лишь сохраняет размер<InlineTokenIcon
        src={'/img/icons/unit size.png'} alt={'Размер отряда'}
      /> Катапульты, а без <span className={'text-supply'}>снабжения</span><InlineTokenIcon
        src={'/img/icons/supply.png'} alt={'Снабжение'}
      /> она, как и все, теряет 2 размера.
        <br/>Потерянный размер Катапульта восстановит только на Казарме — снабжением или докупкой.
      </>}
    />
    <LegendRow
      src={'/img/icons/arrow_down_big.png'} label={<>
      Снабди все три отряда: Катапульта<InlineTokenIcon
      src={'/img/icons/unit d4 friend.png'} isUnitIcon alt={'Катапульта'}
    /> стоит на Казарме<InlineTokenIcon src={'/img/hexes/barracks.efab12f7.png'} alt={'Казарма'}/> и вырастет с 3 до
      максимальных 4<InlineTokenIcon src={'/img/icons/unit size.png'} alt={'Размер отряда'}/>.
    </>}
    />
  </TutorialModal>
);

export const Ch3FortressModal = () => (
  <TutorialModal title={'Крепости'}>
    <LegendRow
      src={'/img/icons/hammer brown.png'} label={<>
      Вентори построили сразу <b>2 крепости</b><InlineTokenIcon
      src={'/img/hexes/special buildings/fortress button.6fed26ae.png'} alt={'Крепость'}
    />.
      <br/>Крепость можно строить на любой ячейке своего города<InlineTokenIcon
      src={'/img/icons/city.42008716.png'} alt={'Город'}
    />, которая не занята другими <span className={'text-construction'}>специальными строениями</span><InlineTokenIcon
      src={'/img/hexes/special buildings/special building.c496c562.png'} alt={'Специальное строение'}
    />.
      <br/>Но <span className={'text-construction'}>достроится</span> она только <span className={'text-construction'}>в конце раунда</span>.
    </>}
    />

    <LegendRow
      src={'/img/icons/fortress_construction.897ca848.png'} label={<>
      Пока крепость не достроена:
      <br/>• Не даёт дополнительной защиты отрядам в этой ячейке.
      <br/>• Не является препятствием для стрельбы<InlineTokenIcon src={'/img/icons/shooting.png'} alt={'Стрельба'}/>.
      <br/>• Не может быть достроена, если в конце раунда <span className={'text-war'}>смежно или на ней стоит вражеский отряд</span>.
      <br/>• Может быть повреждена стрельбой Катапульты<InlineTokenIcon src={'/img/icons/unit d4 friend.png'} isUnitIcon alt={'Катапульта'}/>.
    </>}
    />

    <LegendRow
      src={'/img/icons/arrow_down_big.png'} label={<>
      Подведи Тяжёлую пехоту<InlineTokenIcon src={'/img/icons/unit d10 friend.png'} isUnitIcon alt={'Тяжёлая пехота'}/> к Крепости<InlineTokenIcon
      src={'/img/hexes/special buildings/fortress button.6fed26ae.png'} alt={'Крепость'}
    /> на Руднике<InlineTokenIcon
      src={'/img/hexes/mine.ecae90cd.png'} alt={'Рудник'}
    />, чтобы заблокировать ее строительство.
      <br/>Ко второй, на дальнем Руднике<InlineTokenIcon
      src={'/img/hexes/mine.ecae90cd.png'} alt={'Рудник'}
    />, пока не будем подходить, чтобы увидеть её в деле.
      <br/>Заодно давай стрельнем по Гильдии<InlineTokenIcon
      src={'/img/hexes/special buildings/guild.ee26d2b8.png'} alt={'Гильдия'}
    /> противника, чтобы повредить её.
    </>}
    />
  </TutorialModal>
);

export const Ch3DamagedBuildingModal = () => (
  <TutorialModal title={'Повреждённое строение'}>
    <LegendRow
      src={'/img/icons/shooting.png'} label={<>
      Выстрел Катапульты<InlineTokenIcon src={'/img/icons/unit d4 friend.png'} isUnitIcon alt={'Катапульта'}/> <span className={'text-war'}>с уроном от 4</span><InlineTokenIcon src={'/img/icons/damage.png'} alt={'Урон'}/> наносит <span className={'text-construction'}>строению</span> <span className={'text-war'}>повреждение</span><InlineTokenIcon src={'/img/icons/building_damage.png'} alt={'Повреждение строения'}/>.
    </>}
    />

    <LegendRow
      src={'/img/icons/block red outline.png'} label={<>
      Повреждённое строение <span className={'text-war'}>не работает</span>: Гильдия<InlineTokenIcon
      src={'/img/hexes/special buildings/guild.ee26d2b8.png'} alt={'Гильдия'}
    /> Вентори больше не приносит им доход.
    </>}
    />
    <LegendRow src={'/img/icons/building_damage.png'} label={<>
      <span className={'text-war'}>Второе повреждение разрушает</span> строение.
    </>}/>
    <LegendRow
      src={'/img/icons/hammer brown.png'}
      label={<>
        Для <span className={'text-construction'}>ремонта</span> повреждённого строения в <span className={'text-construction'}>фазе Строительства</span> нужно нажать на ячейку этого строения на поле.
        <br/><span className={'text-construction'}>Ремонт</span> тратит 1 действие<InlineTokenIcon src={'/img/icons/action.png'} alt={'Действие фазы Строительства'}/> <span className={'text-construction'}>фазы Строительства</span>, но не тратит <span className={'text-coins-dark'}>монеты</span>.
    </>}
    />
    <p>
      Вентори придётся тратить своё действие в фазе Строительства, если они захотят, чтобы Гильдия снова работала.
    </p>
    <p>
      А мы пока подготовим штурм<InlineTokenIcon src={'/img/icons/barracks red.png'} alt={'Ближний бой'}/> их города<InlineTokenIcon src={'/img/icons/city.42008716.png'} alt={'Город'}/>.
    </p>
  </TutorialModal>
);

export const Ch3FortressAssaultModal = () => (
  <TutorialModal title={'Штурм крепости'}>

    <LegendRow
      src={'/img/hexes/special buildings/fortress button.6fed26ae.png'}
      label={<>
        Противник достроил Крепость, в которой укрылся его отряд Тяжёлой пехоты<InlineTokenIcon src={'/img/icons/unit d10 enemy.png'} isUnitIcon alt={'Тяжёлая пехота'}/> с <InlineTokenIcon src={'/img/icons/unit size.png'} alt={'Размер отряда'}/>6.
        <br/>Проверим её защиту своим отрядом Пехоты<InlineTokenIcon src={'/img/icons/unit d6 friend.png'} isUnitIcon alt={'Пехота'}/> такого же размера<InlineTokenIcon src={'/img/icons/unit size.png'} alt={'Размер отряда'}/>.
      </>}
    />
    <p>
    </p>
    <LegendRow
      src={'/img/icons/barracks red.png'}
      label={<>
        Крепость<InlineTokenIcon
        src={'/img/hexes/special buildings/fortress button.6fed26ae.png'} alt={'Крепость'}
      /> в <span className={'text-war'}>ближнем бою</span> пропускает пониженный урон по защитнику.
        За каждые <span className={'text-war'}>3</span><InlineTokenIcon
        src={'/img/icons/damage.png'} alt={'Урон'}
      /> по Крепости<InlineTokenIcon
        src={'/img/hexes/special buildings/fortress button.6fed26ae.png'} alt={'Крепость'}
      />:
        <br/>• лишь <span className={'text-war'}>1</span><InlineTokenIcon
        src={'/img/icons/damage.png'} alt={'Урон'}
      /> получает отряд-защитник.
        <br/>• Сама Крепость<InlineTokenIcon
        src={'/img/hexes/special buildings/fortress button.6fed26ae.png'} alt={'Крепость'}
      /> также получает <span className={'text-war'}>1 повреждение</span><InlineTokenIcon
        src={'/img/icons/building_damage.png'} alt={'Повреждение строения'}
      />.
    </>}
    />

    <LegendRow
      src={'/img/icons/exclamation-mark.png'} label={<>
      Крепость<InlineTokenIcon
      src={'/img/hexes/special buildings/fortress button.6fed26ae.png'} alt={'Крепость'}
    /> разрушается, когда получает <span className={'text-war'}>10 повреждений</span><InlineTokenIcon
      src={'/img/icons/building_damage.png'} alt={'Повреждение строения'}
    />.
    </>}
    />

    <LegendRow
      src={'/img/icons/arrow_down_big.png'} label={<>
      Подведи обычную Пехоту<InlineTokenIcon src={'/img/icons/unit d6 friend.png'} isUnitIcon alt={'Пехота'}/> к Крепости<InlineTokenIcon src={'/img/hexes/special buildings/fortress button.6fed26ae.png'} alt={'Крепость'}/>
      и заверши этап Перемещения<InlineTokenIcon src={'/img/icons/speed.png'} alt={'Перемещение'}/>, чтобы начать штурм<InlineTokenIcon src={'/img/icons/barracks red.png'} alt={'Ближний бой'}/>.
    </>}
    />
    <p></p>
  </TutorialModal>
);

export const Ch3AdditionalSupplyModal = () => (
  <TutorialModal title={'Дополнительное снабжение'}>

    <LegendRow
      src={'/img/icons/supply.png'}
      label={<>
        Отряд можно <span className={'text-supply'}>снабдить</span> с ферм<InlineTokenIcon src={'/img/hexes/farm.699e6dfc.png'} alt={'Ферм'}/> <span className={'text-supply'}>дважды</span> за одну <span className={'text-supply'}>фазу Снабжения</span>:
        <br/>• Первый паёк называется <span className={'text-supply'}>базовым снабжением</span><InlineTokenIcon src={'/img/icons/supply.png'} alt={'Снабжение'}/> — он расходуется на рост размера<InlineTokenIcon src={'/img/icons/unit size.png'} alt={'Размер отряда'}/> отряда.
        <br/>• Второй паёк называется <span className={'text-supply'}>дополнительным снабжением</span><InlineTokenIcon src={'/img/icons/supply.png'} alt={'Снабжение'}/>  — он останется у отряда после завершения <span className={'text-supply'}>фазы Снабжения</span> <span className={'text-war'}>до конца раунда</span> (или пока не будет потрачен).
        </>}
    />
    <p>
      <span className={'text-supply'}>Дополнительное снабжение</span><InlineTokenIcon src={'/img/icons/supply.png'} alt={'Снабжение'}/> можно потратить на 1 из 3 преимуществ:
    </p>
    <LegendRow src={'/img/icons/speed.png'} label={<>
      1) +1 к дальности<InlineTokenIcon
      src={'/img/icons/distance.png'} alt={'Дальность'}
    /> перемещения в этом раунде.
    </>}/>
    <LegendRow icon={<TutorialDamageDice isSpinning={true}/>} label={<>
      2) Переброс своих <span className={'text-war'}>костей урона</span> в ближнем бою<InlineTokenIcon src={'/img/icons/barracks red.png'} alt={'Ближний бой'}/> или стрельбе<InlineTokenIcon
      src={'/img/icons/shooting.png'} alt={'Стрельба'}
    />.
    </>}/>
    <LegendRow src={'/img/icons/maneuver_black.png'} label={<>
      3) Манёвр: шаг на 1 ячейку после ближнего боя<InlineTokenIcon src={'/img/icons/barracks red.png'} alt={'Ближний бой'}/> или стрельбы<InlineTokenIcon
      src={'/img/icons/shooting.png'} alt={'Стрельба'}
    />.
    </>}/>

    <LegendRow
      src={'/img/icons/arrow_down_big.png'} label={<>
      У тебя всего <span className={'text-supply'}>3</span><InlineTokenIcon src={'/img/icons/supply.png'} alt={'Снабжение'}/>:
      <br/>• Дай <span className={'text-supply'}>2</span><InlineTokenIcon src={'/img/icons/supply.png'} alt={'Снабжение'}/> обычной Пехоте<InlineTokenIcon src={'/img/icons/unit d6 friend.png'} isUnitIcon alt={'Пехота'}/>
      — отправим её на штурм Крепости<InlineTokenIcon src={'/img/hexes/special buildings/fortress button.6fed26ae.png'} alt={'Крепость'}/>.
      <br/>• Дай <span className={'text-supply'}>1</span><InlineTokenIcon src={'/img/icons/supply.png'} alt={'Снабжение'}/> Катапульте<InlineTokenIcon src={'/img/icons/unit d4 friend.png'} isUnitIcon alt={'Катапульта'}/>.
      <br/>• Тяжёлая пехота<InlineTokenIcon src={'/img/icons/unit d10 friend.png'} isUnitIcon alt={'Тяжёлая пехота'}/> пусть этот раунд поголодает — жертва ради штурма.
    </>}
    /><p>
    </p>
  </TutorialModal>
);

export const Ch3CatapultVsFortressModal = () => (
  <TutorialModal title={'Катапульта против крепостей'}>

    <LegendRow
      src={'/img/icons/unit d4 friend.png'} isUnitIcon
      label={<>
        Катапульта эффективна и против Крепости<InlineTokenIcon src={'/img/hexes/special buildings/fortress button.6fed26ae.png'} alt={'Крепость'}/>, и против отрядов внутри неё:
        выстрел<InlineTokenIcon
        src={'/img/icons/shooting.png'} alt={'Стрельба'}
      /> наносит <span className={'text-war'}>урон</span><InlineTokenIcon
        src={'/img/icons/damage.png'} alt={'Урон'}
      /> по <span className={'text-war'}>обоим</span> сразу и <span className={'text-war'}>без штрафов</span> — отряд теряет размер<InlineTokenIcon src={'/img/icons/unit size.png'} alt={'Размер отряда'}/>, равный <span className={'text-war'}>урону</span><InlineTokenIcon
        src={'/img/icons/damage.png'} alt={'Урон'}
      />, и Крепость<InlineTokenIcon src={'/img/hexes/special buildings/fortress button.6fed26ae.png'} alt={'Крепость'}/> получает столько же <span className={'text-war'}>повреждений</span><InlineTokenIcon
        src={'/img/icons/building_damage.png'} alt={'Повреждение строения'}
      />.
      </>}
    />
    <p>
    </p>

    <LegendRow icon={<TutorialDamageDice isSpinning={true}/>} label={<>
      Катапульта выбросила на <span className={'text-war'}>костях урона</span> значения <TutorialDamageDice value={0} isInline={true}/> и <TutorialDamageDice value={-2} isInline={true}/>. Она не перемещалась<InlineTokenIcon src={'/img/icons/speed.png'} alt={'Перемещение'}/> в этом ходу,
      поэтому засчитана <span className={'text-war'}>лучшая кость</span>:
      <br/><span className={'text-war'}>урон</span> выстрела<InlineTokenIcon
        src={'/img/icons/shooting.png'} alt={'Стрельба'}
      />  = размер<InlineTokenIcon src={'/img/icons/unit size.png'} alt={'Размер отряда'}/>4 + <TutorialDamageDice value={0} isInline={true}/> = <span className={'text-war'}>4</span><InlineTokenIcon
        src={'/img/icons/damage.png'} alt={'Урон'}
      /> — отряд противника <InlineTokenIcon src={'/img/icons/unit d10 enemy.png'} isUnitIcon alt={'Тяжёлая пехота'}/> потерял 4 размера<InlineTokenIcon src={'/img/icons/unit size.png'} alt={'Размер отряда'}/>, а Крепость<InlineTokenIcon src={'/img/hexes/special buildings/fortress button.6fed26ae.png'} alt={'Крепость'}/> получила 4 <span className={'text-war'}>повреждения</span><InlineTokenIcon
        src={'/img/icons/building_damage.png'} alt={'Повреждение строения'}
      />.
    </>}
    />

    <p>
      А вот если бы Катапульта перед выстрелом перемещалась<InlineTokenIcon src={'/img/icons/speed.png'} alt={'Перемещение'}/>, засчиталась бы <span className={'text-war'}>худшая кость</span>{' '}<TutorialDamageDice
      value={-2} isInline={true}
    /> — и <span className={'text-war'}>урон</span> составил бы всего 4<InlineTokenIcon src={'/img/icons/unit size.png'} alt={'Размер отряда'}/> + <TutorialDamageDice value={-2} isInline={true}/> = <span className={'text-war'}>2</span><InlineTokenIcon
      src={'/img/icons/damage.png'} alt={'Урон'}
    />.
    </p>
  </TutorialModal>
);

export const Ch3RerollModal = () => (
  <TutorialModal title={'Переброс костей'}>

    <LegendRow icon={<TutorialDamageDice isSpinning={true}/>} label={<>
      Бросок твоей Пехоты слаб: <TutorialDamageDice value={-2} isInline={true}/> и <TutorialDamageDice value={-3} isInline={true}/>.
      <br/>Итоговый урон = <InlineTokenIcon src={'/img/icons/unit size.png'} alt={'Размер отряда'}/>6 + <TutorialDamageDice value={-2} isInline={true}/> + <TutorialDamageDice value={-3} isInline={true}/> = <span className={'text-war'}>1</span><InlineTokenIcon
        src={'/img/icons/damage.png'} alt={'Урон'}
      />.
      При таком раскладе ты не нанесёшь повреждений ни Крепости, ни отряду противника, так как <span className={'text-war'}>урон меньше 3</span>.
      </>}
    />

    <LegendRow src={'/img/icons/supply.png'} label={<>
      Но у отряда<InlineTokenIcon src={'/img/icons/unit d6 friend.png'} isUnitIcon alt={'Пехота'}/> есть <span className={'text-supply'}>дополнительное снабжение</span><InlineTokenIcon src={'/img/icons/supply.png'} alt={'Снабжение'}/> — можно перебросить <span className={'text-war'}>кости урона</span>{' '}<TutorialDamageDice value={0} isInline={true}/>!
    </>}
    />
    <LegendRow
      src={'/img/icons/arrow_down_big.png'} label={<>
      Нажми на свой отряд<InlineTokenIcon src={'/img/icons/unit d6 friend.png'} isUnitIcon alt={'Пехота'}/>, выбери ОБЕ <span className={'text-war'}>кости</span>{' '}<TutorialDamageDice value={-2} isInline={true}/><TutorialDamageDice value={-3} isInline={true}/> и нажми «Перебросить».
    </>}
    />
  </TutorialModal>
);

export const Ch3ManeuverModal = () => (
  <TutorialModal title={'Манёвр'}>
    <LegendRow src={'/img/icons/maneuver_black.png'} label={<>
      Отряд, который в этом ходу стрелял<InlineTokenIcon
      src={'/img/icons/shooting.png'} alt={'Стрельба'}
    /> или сражался в ближнем бою<InlineTokenIcon src={'/img/icons/barracks red.png'} alt={'Ближний бой'}/> и сохранил <span className={'text-supply'}>дополнительное снабжение</span><InlineTokenIcon src={'/img/icons/supply.png'} alt={'Снабжение'}/>, может шагнуть на 1 ячейку на <span className={'text-war'}>этапе Манёвра</span>.
    </>}/>

    <LegendRow
      src={'/img/icons/unit d4 friend.png'} label={<>
      Катапульта стреляла<InlineTokenIcon
      src={'/img/icons/shooting.png'} alt={'Стрельба'}
    /> — сманеврируй<InlineTokenIcon
      src={'/img/icons/maneuver_black.png'} alt={'Манёвр'}
    /> её на ячейку дороги<InlineTokenIcon src={'/img/hexes/road.1f281346.png'} alt={'Дорога'}/>, ближе к фронту.
    </>}
    />
  </TutorialModal>
);

export const Ch3FortressDefenseModal = () => (
  <TutorialModal title={'Цена штурма'}>
    <p>
      Отлично! После переброса наш отряд<InlineTokenIcon src={'/img/icons/unit d6 friend.png'} isUnitIcon alt={'Пехота'}/> нанёс <span className={'text-war'}>6</span><InlineTokenIcon
      src={'/img/icons/damage.png'} alt={'Урон'}
    />.
      <br/>А значит, и отряд противника<InlineTokenIcon src={'/img/icons/unit d10 enemy.png'} isUnitIcon alt={'Тяжёлая пехота'}/> получил <span className={'text-war'}>2</span><InlineTokenIcon
      src={'/img/icons/damage.png'} alt={'Урон'}
    />, и Крепость<InlineTokenIcon src={'/img/hexes/special buildings/fortress button.6fed26ae.png'} alt={'Крепость'}/> получила <span className={'text-war'}>2 повреждения</span><InlineTokenIcon
      src={'/img/icons/building_damage.png'} alt={'Повреждение строения'}
    />.
    </p>
    <p>
      А вот твой отряд <InlineTokenIcon src={'/img/icons/unit d6 friend.png'} isUnitIcon alt={'Пехота'}/> был полностью уничтожен:
      <br/>отряд противника<InlineTokenIcon src={'/img/icons/unit d10 enemy.png'} isUnitIcon alt={'Тяжёлая пехота'}/> нанёс ему тоже <span className={'text-war'}>6</span><InlineTokenIcon
      src={'/img/icons/damage.png'} alt={'Урон'}
    />. Но, так как у твоего отряда не было защиты в виде Крепости<InlineTokenIcon src={'/img/hexes/special buildings/fortress button.6fed26ae.png'} alt={'Крепость'}/>, он потерял все 6 размера<InlineTokenIcon src={'/img/icons/unit size.png'} alt={'Размер отряда'}/>!
    </p>
    <p>
      Лобовой штурм крепостей — дорогое удовольствие. Дальше дело катапульты.
    </p>
  </TutorialModal>
);

export const Ch3ShotHitsAllModal = () => (
  <TutorialModal title={'Обстрел крепости'}>
    <LegendRow
      src={'/img/icons/shooting.png'} label={<>
      Выстрел Катапульты по Крепости наносит ей повреждения <b>1 к 1</b> — и одновременно
      бьёт по отряду, укрывшемуся внутри. Гарнизон пал, а стены уже трещат.
    </>}
    />
    <p>
      Ещё один точный выстрел — и крепость рухнет.
    </p>
  </TutorialModal>
);

export const Ch3FortressDestroyedModal = () => (
  <TutorialModal title={'Крепость разрушена!'}>
    <LegendRow
      src={'/img/icons/shooting.png'} label={<>
      Последний выстрел довёл повреждения Крепости<InlineTokenIcon src={'/img/hexes/special buildings/fortress button.6fed26ae.png'} alt={'Крепость'}/> до 10<InlineTokenIcon
      src={'/img/icons/building_damage.png'} alt={'Повреждение строения'}
    /> — Крепость разрушена.
    </>}
    />

    <LegendRow
      src={'/img/icons/arrow_down_big.png'} label={<>
      Заверши ход и готовь Тяжёлую пехоту<InlineTokenIcon src={'/img/icons/unit d10 friend.png'} isUnitIcon alt={'Тяжёлая пехота'}/> к последнему удару.</>}
    />
    <p>
    </p>
  </TutorialModal>
);

export const Ch3CaptureCityModal = () => (
  <TutorialModal title={'Захват форпоста'}>
    <LegendRow
      src={'/img/icons/city.42008716.png'} label={<>
      Город Вентори остался без защиты — пора его захватить.
    </>}
    />
    <LegendRow
      src={'/img/icons/win points.png'} label={<>
      Вентори потеряют очки за каждое строение города<InlineTokenIcon
      src={'/img/icons/city.42008716.png'} alt={'Город'}
    /> — а ты столько же получишь!
    </>}
    />

    <LegendRow
      src={'/img/icons/arrow_down_big.png'} label={<>
      Перемести Тяжёлую пехоту<InlineTokenIcon src={'/img/icons/unit d10 friend.png'} isUnitIcon alt={'Тяжёлая пехота'}/> на <span className={'text-construction'}>квартал</span> города<InlineTokenIcon
      src={'/img/icons/city.42008716.png'} alt={'Город'}
    /> Вентори, чтобы его захватить.
    </>}
    />
  </TutorialModal>
);
